export const sortByDateDescending = (a, b) => (a.date > b.date) ? -1 : ((a.date < b.date) ? 1 : 0);
export const sortByDateAscending = (a, b) => (a.date < b.date) ? -1 : ((a.date > b.date) ? 1 : 0);

export const sortByName = (a, b) => a.name.localeCompare(b.name);
export const sortByNameReverse = (a, b) => b.name.localeCompare(a.name);
export const sortByLabel = (a, b) => a.label.localeCompare(b.label);
export const sortByAthleteName = (a, b) => a.athlete.name.localeCompare(b.athlete.name);
export const sortByEventDivisionName = (a, b) => a.eventDivision.division.name.localeCompare(b.eventDivision.division.name);
